"use strict";

exports.__esModule = true;
exports.VIDEO_UPLOAD_SIZE_LIMIT_MB = exports.FILE_UPLOAD_SIZE_LIMIT_MB = void 0;
var FILE_UPLOAD_SIZE_LIMIT_MB = 100;
exports.FILE_UPLOAD_SIZE_LIMIT_MB = FILE_UPLOAD_SIZE_LIMIT_MB;
var VIDEO_UPLOAD_SIZE_LIMIT_MB = 500;
exports.VIDEO_UPLOAD_SIZE_LIMIT_MB = VIDEO_UPLOAD_SIZE_LIMIT_MB;